import React, { useState, useEffect } from "react";
import { FloatingHeader } from "../components/landing/FloatingHeader";
import { HeroSection, TransformationSection } from "../components/landing/HeroSections";
import { PackagesSection, AddOnsSection, WhyDoozyGoSection, HowItWorksSection, UrgencySection, FinalCTASection } from "../components/landing/Sections";
import { OnlineBookingSection } from "../components/landing/OnlineBookingSection";
import { ReviewsSection } from "../components/landing/ReviewsSection";
import { LeadCapturePopup, OfferBanner, SocialReferralSection, Footer } from "../components/landing/InteractiveSections";
import { PartyDNASection } from "../components/landing/PartyDNA";
import { PlanWithFriendsTeaser } from "../components/landing/PlanWithFriendsTeaser";
import CreatorSpotlightCard from "../components/landing/CreatorSpotlightCard";

const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [bannerHeight, setBannerHeight] = useState(0);
  const [capturedCustomer, setCapturedCustomer] = useState(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App min-h-screen" data-testid="doozygo-landing">
      <LeadCapturePopup onCapture={setCapturedCustomer} />
      <OfferBanner onHeight={setBannerHeight} />
      <FloatingHeader isScrolled={isScrolled} topOffset={bannerHeight} />
      <div style={{ paddingTop: `${bannerHeight}px` }}>
        <main>
          <HeroSection />
          <TransformationSection />
          <PackagesSection />
          <PartyDNASection />
          <PlanWithFriendsTeaser />
          <CreatorSpotlightCard />
          <OnlineBookingSection capturedCustomer={capturedCustomer} />
          <AddOnsSection />
          <ReviewsSection />
          <WhyDoozyGoSection />
          <HowItWorksSection />
          <SocialReferralSection />
          <UrgencySection />
          <FinalCTASection />
        </main>
        <Footer />
      </div>
      {/* DPDP banner mounts globally from App.js → DPDPGate; no per-page mount needed */}
    </div>
  );
};

export default LandingPage;
